// @flow
import jwtDecode from 'jwt-decode';
import { Reducer } from 'redux';
import { IReduxAction } from 'app/types/actions';
import {
  AuthenticationActionTypes as types,
  IAuthenticationState,
} from './types';

const initialState: IAuthenticationState = {
  cognitoUser: undefined,
  isAuthenticated: false,
  isForgottenPassword: false,
  isLoading: false,
  redirectLocation: undefined,
  organisationId: null,
  loginAttempts: 0,
  user: {
    email: '',
    password: '',
  },
};

const reducer: Reducer<IAuthenticationState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.USER_LOGOUT:
      return {
        ...state,
        redirectLocation: action.payload.redirectLocation,
      };

    case types.AUTHENTICATE_COGNITO_USER_PENDING:
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        hasFailed: false,
        backendErrors: {},
        organisationId: null,
      };

    case types.AUTHENTICATE_COGNITO_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        isAuthenticated: true,
        hasFailed: false,
        user: {
          id: jwtDecode(action.payload.idToken.jwtToken).sub,
        },
        backendErrors: {},
        organisationId: action.payload.organisationId,
        authenticationPending: false,
        redirectLocation: undefined,
        changePasswordSuccess: false,
      };

    case types.SWITCH_ORGANISATION:
      return {
        ...state,
        organisationId: action.payload.organisationId,
      };

    case types.AUTHENTICATE_COGNITO_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        backendErrors: action.payload.backendErrors,
        isAuthenticated: false,
        hasFailed: true,
        hasLoaded: false,
      };

    case types.CHANGE_PASSWORD_PENDING:
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        hasFailed: false,
        backendErrors: {},
        changePasswordSuccess: false,
      };

    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        hasLoaded: true,
        hasFailed: false,
        changePasswordSuccess: true,
        backendErrors: {},
      };

    case types.CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false,
        hasLoaded: false,
        hasFailed: true,
        backendErrors: action.payload.backendErrors,
        isAuthenticated: false,
      };
    case types.FORGOT_PASSWORD_PENDING:
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        hasFailed: false,
        backendErrors: {},
      };

    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        isForgottenPassword: true,
        hasFailed: false,
        forgottenPasswordEmail: action.payload.email,
        backendErrors: {},
      };

    case types.FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false,
        hasFailed: true,
        backendErrors: action.payload.backendErrors,
        isAuthenticated: false,
      };

    case types.REFRESH_COGNITO_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        authenticationPending: false,
      };

    case types.RESET_AUTHENTICATE_ERRORS:
      return {
        ...state,
        isLoading: false,
        backendErrors: {},
      };

    default:
      return state;
  }
};

export default reducer;
